<template>
  <div class="main-wrap policy-page">
    <main-header to="/" />
    <div class="container-general pt-15 policy-content-wrap">
      <v-container class="pb-10 pb-md-14">
        <v-row justify="center">
          <v-col cols="12" md="11" lg="9" class="px-4 px-sm-3">
            <div class="policy-hero rounded-xl px-4 px-sm-7 py-6 py-md-10 mb-6 mb-md-8">
              <p class="policy-kicker mb-3">{{ $t('header.policy') }}</p>
              <h1 class="policy-title mb-3 mb-md-4">{{ $t('header.policy') }}</h1>
              <p class="policy-description mb-0">{{ $t('policy.privacyDesc') }}</p>
            </div>

            <v-card class="policy-markdown rounded-xl pa-1 pa-md-10" elevation="0">
              <v-md-editor v-model="file" mode="preview"></v-md-editor>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div id="footer">
      <main-footer />
    </div>
  </div>
</template>
  
<style lang="scss" scoped>
@import "~/assets/pages";

.policy-page {
  --policy-primary: #3f51b5;
  --policy-secondary: #f44336;
}

.policy-content-wrap {
  position: relative;
  z-index: 1;
}

.policy-hero {
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.88));
  border: 1px solid rgba(63, 81, 181, 0.16);
  box-shadow: 0 14px 35px rgba(37, 55, 133, 0.1);
}

.policy-kicker {
  color: #5463bd;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
}

.policy-title {
  color: #1f2e79;
  font-size: clamp(1.75rem, 1.35rem + 1.45vw, 2.6rem);
  line-height: 1.2;
  font-weight: 900;
}

.policy-description {
  color: #4d5b70;
  max-width: 780px;
  line-height: 1.8;
}

.policy-markdown {
  border-radius: 20px !important;
  border: 1px solid rgba(63, 81, 181, 0.14);
  background: #ffffff !important;
  box-shadow: 0 18px 42px rgba(38, 55, 128, 0.11);
  overflow: hidden;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    inset: 0 0 auto 0;
    height: 5px;
    background: linear-gradient(90deg, var(--policy-primary), var(--policy-secondary));
    z-index: 2;
  }

  ::v-deep .v-md-editor-preview {
    font-size: 1.08rem;
    line-height: 1.85;
    color: #28333f;

    h1, h2, h3, h4, h5, h6 {
      color: #1c2a6f;
      font-weight: 800;
      margin-top: 2.2rem;
      margin-bottom: 0.9rem;
    }

    h1 {
      font-size: 2rem;
      border-bottom: 2px solid rgba(63, 81, 181, 0.12);
      padding-bottom: 0.45rem;
    }

    p {
      margin-bottom: 1.2rem;
      color: #3e4b5d;
    }

    a {
      color: var(--policy-primary);
      font-weight: 600;
      text-decoration: none;
      border-bottom: 1px solid rgba(63, 81, 181, 0.35);
    }

    blockquote {
      background: #f7f8ff;
      border-left: 4px solid var(--policy-primary);
      padding: 1rem 1.2rem;
      border-radius: 8px;
      margin: 1.5rem 0;
    }

    pre {
      border-radius: 10px;
    }
  }
}

@media (max-width: 960px) {
  .policy-hero {
    padding: 1.2rem 1rem !important;
  }

  .policy-markdown {
    padding: 0.25rem !important;

    ::v-deep .v-md-editor-preview {
      font-size: 1rem;
      h1 { font-size: 1.7rem; }
      h2 { font-size: 1.45rem; }
    }
  }
}

@media (max-width: 600px) {
  .policy-title {
    font-size: 1.5rem;
  }

  .policy-description {
    font-size: 0.95rem;
    line-height: 1.7;
  }

  .policy-markdown ::v-deep .v-md-editor-preview {
    font-size: 0.96rem;
    line-height: 1.72;
  }
}
</style>
  
<script>
import BlogHeader from "~/components/Header/BlogHeader";
import Footer from "~/components/Footer";

export default {
  components: {
    "main-header": BlogHeader,
    "main-footer": Footer
  },
  async asyncData({ $axios, params, i18n }) {
    return {
      file: (await $axios.get(`/file/assets?path=${i18n.t("policy.privacy")}`))
        .data
    };
  },
  head() {
    return {
      title: this.$t("brand.name") + " - " + this.$t("header.policy"),
      meta: [
        {
          name: "description",
          content: this.$t("policy.privacyDesc"),
          hid: "description"
        }
      ],
    };
  }
};
</script>
  